import { PageContractors } from "@components/modules/contractors/listing/PageContractors";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationContractors } from "@src/components/widgets/AppSubNav/navigation-contractors";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Contractors`} navigation={<NavigationContractors />}>
    <DemoModule module={Modules.Contractors}>
      <PageContractors />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/contractors/")({
  component: Page,
});
